import { useCallback, useState } from "react"
import { validateFields, validationFieldTypes } from "src/utils";
import { FieldRequirement, FormValues } from "./Types/useForm.types";

export const useForm = () => {

    const [formValues, setFormValues] = useState<FormValues>({})


    const handleValues = useCallback((name: string, fieldValues: FieldRequirement) => {
        setFormValues((prev) => ({ ...prev, [name]: fieldValues }))
    }, [])

    const register = (name: string) => {
        const fieldValue = formValues[name] || setFormValues((prev) =>
        ({
            ...prev,
            [name]: { value: "", errorMsg: "", isRequired: false, }
        }));

        return { id: name, name, value: fieldValue, setValue: (field: FieldRequirement) => handleValues(name, field) }
    }

    const handleSubmit = useCallback((onValid: (formValues: FormValues) => void) => (e: any) => {
        e?.preventDefault && e.preventDefault()
        let isValid = true
        Object.entries(formValues).forEach(([key, value]) => {
            const isInputsValid =
                validateFields({ setter: setFormValues, value: formValues[key].value, name: key, isRequired: value.isRequired, mode: validationFieldTypes.Form })
            if (isInputsValid) isValid = false;
        })
        if (isValid) onValid(formValues)
    }, [formValues])

    return { register, handleSubmit, formValues, handleValues }

} 
